import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map, switchMap } from "rxjs/operators";

import { UmbracoIndstillingerObserver } from "@e-forsyning/common/umbraco-indstillinger";

import { KontaktViewModel } from "../model/kontakt.view-model";
import { KontaktRepository } from "./kontakt.repository";

@Injectable({ providedIn: "root" })
export class KontaktService {
    constructor(private readonly repository: KontaktRepository, private readonly umbracoIndstillinger: UmbracoIndstillingerObserver) {}

    public hent(): Observable<KontaktViewModel> {
        const indstillinger$ = this.repository.hentIndstillinger();
        const kontakt$ = this.umbracoIndstillinger.valueChanges.pipe(
            switchMap((i) => this.repository.hentKontakt(i.aktuelEforsyningNodeId))
        );
        return combineLatest([indstillinger$, kontakt$]).pipe(map(([indstillinger, kontakt]) => ({ indstillinger, kontakt })));
    }
}
